// extracted by mini-css-extract-plugin
export var borderRadius = "_ez-4";
export var large = "_ez-3";
export var logoContainer = "_ez-0";
export var nameLogo = "_ez-2";
export var small = "_ez-1";